import type {BackendTestAppsEnvironment, ClientCredentialsTarget} from './auth';

export enum RouteFamily {
  CORE = 'core',
  PLUTUS = 'plutus',
  CORE_WEB = 'core-web',
  CORE_CC = 'core-cc',
  PLUTUS_CC = 'plutus-cc',
  APOLLO_CC = 'apollo-cc',
  LOCAL = 'local',
}

export enum RequestExecutionMode {
  DIRECT = 'direct',
  BROKERED = 'brokered',
  PASSTHROUGH = 'passthrough',
}

export enum RequestAuthMode {
  USER_BEARER = 'user-bearer',
  CLIENT_CREDENTIALS = 'client-credentials',
  NONE = 'none',
}

export enum RequestAuthTokenSource {
  NONE = 'none',
  PREEXISTING_AUTHORIZATION_HEADER = 'preexisting-authorization-header',
  BROWSER_MEMORY_CACHE = 'browser-memory-cache',
  AUTHTOKEN_ENDPOINT = 'authtoken-endpoint',
  CC_MEMORY_CACHE = 'cc-memory-cache',
  CC_KV_CACHE = 'cc-kv-cache',
  CC_PROVIDER = 'cc-provider',
}

export interface RouteRule {
  family: RouteFamily;
  prefix: string;
  rewrite: string;
  target: string | undefined;
  requiresUserAuth?: boolean;
  requiresClientCredentials?: boolean;
}

export interface TargetedRouteRule extends RouteRule {
  target: string;
}

export interface ResolvedRequest {
  url: string;
  headers?: Record<string, string>;
  family: RouteFamily;
  executionMode: RequestExecutionMode;
  authMode: RequestAuthMode;
  tokenSource: RequestAuthTokenSource;
  matchedPrefix?: string;
  logicalPath: string;
  environment?: BackendTestAppsEnvironment;
}

export interface ResolveRequestInput {
  url: string;
  headers?: HeadersInit;
}

export interface ClientCredentialsResolution {
  token?: string;
  tokenSource: RequestAuthTokenSource;
  target: ClientCredentialsTarget;
}
